<template>
    <div>
        <div style="width: 100%;">
            <form @submit="save">
                <table style="width: 100%;">
                    <tr style="text-decoration: underline;">
                        <td>
                            #
                        </td>
                        <td>
                            Media Analyst Manager
                        </td>
                        <td>

                        </td>
                    </tr>
                    <tr v-for="row of rows">
                        <td>
                            {{ row.id }}
                        </td>
                        <td>
                            <div v-if="!row.edit">{{ row.media_analyst_manager }}</div>
                            <b-form-input v-if="row.edit" type="text" v-model="row.media_analyst_manager" placeholder="Media Analyst Manager" />
                        </td>
                        <td>
                            <div v-if="!row.edit">
                                <a v-if="isAdmin" class="btn btn-primary" href="javascript:void(0);" @click="editRow(row.id)">Edit</a> <a class="btn btn-primary" href="javascript:void(0);" @click="deleteEntity(row.id)" v-if="isAdmin">Delete</a>
                            </div>
                            <div v-if="row.edit">
                                <a class="btn btn-primary" href="javascript:void(0);"
                                    @click="saveEditRow(row.id)">Save</a>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="isAdmin && showNewRow">
                        <td>

                        </td>
                        <td>
                            <b-form-input type="text" v-model="newRow.media_analyst_manager" placeholder="Media Analyst Manager" />
                        </td>
                        <td>
                            <input type="submit" class="btn btn-success" value="Add" />
                        </td>
                    </tr>
                </table>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            newRow: {
                id: 0,
                media_analyst_manager: '',
            },
            rows: [],
            showNewRow: true,
            isAdmin: true
        };
    },
    async created() {
        const permList = await this.$store.state.user.perms;
        if (Object.values(permList).indexOf("bundles.admin") > -1) {
            this.isAdmin = true;
        }
        this.getListData();
    },
    methods: {
        async save(e) {
            e.preventDefault();
            const data = await this.$http.post(this.resources.Management.saveMediaAnalystManager, {
                ...this.newRow
            });
            this.newRow.media_analyst_manager = "";
            this.getListData();
        },
        async getListData() {
            const data = await this.$http.post(this.resources.Management.getMediaAnalystManagers, {});
            for (let k in data.body.data) {
                data.body.data[k].edit = false
            }
            this.rows = data.body.data
        },
        async deleteEntity(id) {
            id = parseInt(id);
            const data = await this.$http.post(this.resources.Management.deleteMediaAnalystManager, {
                id,
            });
            console.log(data.body);
            if (data.body.res === 'OK') {
                this.getListData();
            } else {
                console.log(data.body.msg);
                this.notifyError( 'Media Analyst id '+ id + ' ' + data.body.msg)
            }
            
        },
        async editRow(id) {
            this.showNewRow = false;
            for (let k in this.rows) {
                if (this.rows[k].id == id) {
                    this.rows[k].edit = true;
                }
                else {
                    this.rows[k].edit = false;
                }
            }
        },
        async saveEditRow(id) {
            let editRowData = {};
            for (let k in this.rows) {
                if (this.rows[k].id === id) {
                    editRowData = this.rows[k];
                }
            }
            
            this.showNewRow = true;
            const data = await this.$http.post(this.resources.Management.saveMediaAnalystManager, {
                ...editRowData
            });
            this.getListData()
            
        },
    },
}
</script>

<style scoped>
.link-div {
    padding-top: 40px;
    text-align: center;
}
</style>
